/** global jQuery */

export default class ProductShowcase {
  ready() {
    jQuery('body').on('click', '.mtt-product.mtt-product--showcase .mtt-product__payment-types .mtt-product__payment-type-label', (e) => {
      e.preventDefault()

      const labelElement = jQuery(e.currentTarget)
      const paymentType = labelElement.attr('data-payment-type')

      // Remove active class from all labels
      labelElement.closest('.mtt-product__text-container')
        .find('.mtt-product__payment-type-label')
        .removeClass('active')
      // Remove show class from all prices
      labelElement.closest('.mtt-product__text-container')
        .find('.mtt-product__prices')
        .removeClass('show')

      // Add active class to the clicked label
      labelElement.addClass('active')
      // Add show class to the prices of the clicked label
      labelElement.closest('.mtt-product__text-container')
        .find('.mtt-product__prices[data-prices="' + paymentType + '"]')
        .addClass('show')
    })
  }
}